// Felt-grupper på frontend. Holder synkron med backend/src/lib/field-groups.ts.
// Brugeren vælger individuelle felter (ikke hele grupper) — vi grupperer dem
// kun i UI'en for overskuelighed.

export const FIELD_GROUPS = [
  {
    code: 'inventory',
    minPlan: 'free',
    fields: ['quantity', 'unit', 'lowStockThreshold'],
  },
  {
    code: 'identification',
    minPlan: 'free',
    fields: ['brand', 'model', 'serialNumber'],
  },
  {
    code: 'purchase',
    minPlan: 'free',
    fields: ['purchaseLocation', 'acquiredAt', 'priceCents', 'warrantyExpiresAt', 'insuranceValueCents'],
  },
  {
    code: 'appearance',
    minPlan: 'free',
    fields: ['color', 'size', 'material'],
  },
  {
    code: 'condition',
    minPlan: 'free',
    fields: ['condition', 'conditionNote'],
  },
  {
    code: 'books',
    minPlan: 'free',
    fields: ['author', 'publisher', 'publishedYear', 'isbn'],
  },
  {
    code: 'vehicle',
    minPlan: 'free',
    fields: ['registrationNumber', 'vin', 'modelYear'],
  },
] as const;

export type FieldGroupCode = (typeof FIELD_GROUPS)[number]['code'];
export type FieldName = (typeof FIELD_GROUPS)[number]['fields'][number];

export const FIELD_GROUP_CODES: FieldGroupCode[] = FIELD_GROUPS.map((g) => g.code);

export const KNOWN_FIELDS: FieldName[] = FIELD_GROUPS.flatMap((g) => [...g.fields]);

export const CONDITIONS = [
  'new',
  'used_like_new',
  'used_good',
  'used_fair',
  'worn',
  'broken',
] as const;

export type Condition = (typeof CONDITIONS)[number];

export function fieldsInGroup(code: FieldGroupCode): readonly FieldName[] {
  return FIELD_GROUPS.find((g) => g.code === code)!.fields;
}

export function groupOfField(field: FieldName): FieldGroupCode {
  for (const g of FIELD_GROUPS) {
    if ((g.fields as readonly FieldName[]).includes(field)) return g.code;
  }
  throw new Error(`Unknown field: ${field}`);
}

/** Returnerer alle felter (uanset gruppe) der har værdi på item'en. */
export function activeFieldsFromValues(item: Record<string, unknown>): FieldName[] {
  const active: FieldName[] = [];
  for (const f of KNOWN_FIELDS) {
    const v = item[f];
    if (v !== null && v !== undefined && v !== '') active.push(f);
  }
  return active;
}
